import { LabelLarge, useStyletron } from "@mezo-org/mezo-clay"

import MatsReward from "#/shared/components/MatsReward"
import { bigIntToHumanReadableFormat, stakingUtils } from "#/shared/utils"

type StakingRewardsLabelProps = {
  veBTC: bigint
}

export default function StakingRewardsLabel({
  veBTC,
}: StakingRewardsLabelProps) {
  const [css, theme] = useStyletron()

  if (!veBTC) return <LabelLarge>0.0</LabelLarge>

  const mats = stakingUtils.getEstimatedMatsReward(veBTC)

  return (
    <LabelLarge
      className={css({
        display: "flex",
        whiteSpace: "pre-wrap",
      })}
    >
      {bigIntToHumanReadableFormat(veBTC)}

      {mats > 0 && (
        <>
          {" + "}
          <MatsReward
            label={
              <LabelLarge marginRight={theme.sizing.scale100}>
                {mats}
              </LabelLarge>
            }
          />
        </>
      )}
    </LabelLarge>
  )
}
